var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cells",class:[ _vm.positions[_vm.position], { 'cells--indent': _vm.indent }, { 'cells--wrap': _vm.wrap } ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }